import ViewGridIcon from '@heroicons/react/outline/esm/ViewGridIcon.js'
import ViewGridSolidIcon from '@heroicons/react/solid/esm/ViewGridIcon.js'
import { Link, useLocation } from 'react-router-dom'

import { Collection } from '@tribeplatform/gql-client/types'
import { SystemSpaceSlug, useSpaceUtil } from '@tribeplatform/react-sdk/hooks'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

export const CollectionMenuSimple = ({
  collections,
  ...rest
}: {
  collections: Collection[]
}) => {
  const { generatePath, matchPath } = useSpaceUtil()
  const location = useLocation()

  return (
    <NavVertical {...rest}>
      <div className="space-y-2">
        {collections.map(collection => {
          const hasSpaces = collection?.spaces?.totalCount
          const isActive = matchPath(
            SystemSpaceSlug.COLLECTION,
            location.pathname,
            { id: collection.id },
          )

          if (!hasSpaces) {
            return null
          }

          return (
            <NavVertical.Group key={collection.id}>
              <NavVertical.Item
                // className="group"
                active={!!isActive}
                as={Link}
                to={generatePath(SystemSpaceSlug.COLLECTION, {
                  id: collection.id,
                })}
                leadingIcon={
                  isActive ? <ViewGridSolidIcon /> : <ViewGridIcon />
                }
              >
                <span className="truncate flex-grow font-semibold text-sm text-content-on-background-subdued">
                  {collection.name}
                </span>
              </NavVertical.Item>
            </NavVertical.Group>
          )
        })}
      </div>
    </NavVertical>
  )
}
